// extracted by mini-css-extract-plugin
module.exports = {"container":"_ymUGgDJS","amount":"_TYA4nkxr","button":"_OlwXElF5","heading":"_Z-LYOl8h","content":"_0KrWLtEC"};